import { string, func, object } from "prop-types"
import Icon from "components/planning_center_icon"
import { isBlank } from "utils/helpers"
import { css } from "@emotion/core"

const searchInputStyles = css`
  padding-left: 32px !important;
  --text-input--border-width: 0;
  --text-input--border-radius: 3px 3px 0 0;
`

const searchClearIcon = css`
  cursor: pointer;
  color: var(--t-fill-color-neutral-040);
  font-size: 14px;
  position: absolute;
  top: 17px;
  right: 1rem;
`

const SearchInput = ({ placeholder, value, onChange, onClear, style, onKeyDown = () => null }) => {
  return (
    <div className="f-1">
      <div
        className="prepended-label d-f"
        css={{
          "--text-input--height": "48px"
        }}
      >
        <span className="label c-neutral-400" css={{ top: "9px" }}>
          <Icon symbol="general#search" aria-hidden />
        </span>
        <input
          type="text"
          placeholder={placeholder}
          aria-label={placeholder}
          onKeyDown={onKeyDown}
          value={value}
          onChange={onChange}
          className="big-input"
          css={searchInputStyles}
          style={style}
        />
        {!isBlank(value) && (
          <button onClick={onClear} css={searchClearIcon}>
            <Icon symbol="general#x" />
          </button>
        )}
      </div>
    </div>
  )
}

SearchInput.propTypes = {
  placeholder: string.isRequired,
  value: string.isRequired,
  onChange: func.isRequired,
  onClear: func.isRequired,
  onKeyDown: func,
  style: object
}

export default SearchInput
